export const TRANSACTIONS_PAGE_SIZE = 9;
